export default async function deleteUser(userId, user) {
    try {
        const userSession = JSON.parse(sessionStorage.getItem("user"));

        if (!userSession || !userSession.token) {
            throw new Error("Dados insuficientes no sessionStorage.");
        }

        const { token } = userSession;

        console.log("Parâmetros recebidos:", { userId, user });

        const response = await fetch(`${process.env.REACT_APP_OPENAI_SERVER_EXPRESS}/users/delete/${userId}/${user}`, {
            method: "DELETE", // Método HTTP para deletar
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(`Erro ao deletar usuário: ${errorData.error || response.statusText}`);
        }

        const data = await response.json();

        if (!data) {
            throw new Error("Resposta inválida da API.");
        }

        console.log("Usuário deletado com sucesso:", data);
        return data; // Retorna o resultado da API
    } catch (error) {
        console.error("Erro ao deletar usuário:", error.message);
        throw error; // Propaga o erro para tratamento externo
    }
}
